import React from 'react';
import { Box, Stack } from '@mui/material';
import CareLogCard from './CareLogCard';

const CareLogEntryCard = ({
  category = 'log',
  tone = null,
  important = false,
  selected = false,
  variant = 'default',
  compact = false,
  showLeftRail = true,
  leftRailColor = null,
  leftRailOpacity = 0.68,
  leftRailWidth = 3,
  leftRailTop = '16%',
  leftRailBottom = '16%',
  leftRailSx = {},
  headerNode = null,
  titleNode = null,
  bodyNode = null,
  footerNode = null,
  topRightNode = null,
  children = null,
  contentSpacing = null,
  sx = {},
  contentSx = {},
  ...cardProps
}) => {
  const spacing = contentSpacing || (compact ? 0.72 : 0.9);

  return (
    <CareLogCard
      category={category}
      tone={tone}
      important={important}
      selected={selected}
      variant={variant}
      compact={compact}
      showLeftRail={showLeftRail}
      leftRailColor={leftRailColor}
      leftRailOpacity={leftRailOpacity}
      leftRailWidth={leftRailWidth}
      leftRailTop={leftRailTop}
      leftRailBottom={leftRailBottom}
      leftRailSx={leftRailSx}
      sx={sx}
      {...cardProps}
    >
      {topRightNode ? (
        <Box
          sx={{
            position: 'absolute',
            top: variant === 'story' ? { xs: 18, sm: 20 } : 4,
            right: variant === 'story' ? { xs: 18, sm: 22 } : 4,
            zIndex: 1,
          }}
        >
          {topRightNode}
        </Box>
      ) : null}
      <Stack spacing={spacing} sx={{ minWidth: 0, ...contentSx }}>
        {headerNode ? <Box sx={{ minWidth: 0 }}>{headerNode}</Box> : null}
        {titleNode ? <Box sx={{ minWidth: 0 }}>{titleNode}</Box> : null}
        {bodyNode ? <Box sx={{ minWidth: 0 }}>{bodyNode}</Box> : null}
        {children ? <Box sx={{ minWidth: 0 }}>{children}</Box> : null}
        {footerNode ? <Box sx={{ minWidth: 0 }}>{footerNode}</Box> : null}
      </Stack>
    </CareLogCard>
  );
};

export default React.memo(CareLogEntryCard);
